const ApiService = Shopware.Classes.ApiService;

/**
 * @class
 * @extends ApiService
 */
class TrustpilotConfigurationService extends ApiService {
    /**
     * @constructor
     * @param {AxiosInstance} httpClient
     * @param loginService
     * @param context
     * @param apiEndpoint
     */
    constructor(httpClient, loginService, context, apiEndpoint = 'ecocode/trustpilot') {
        super(httpClient, loginService, apiEndpoint);
        this.name = 'ecocodeTrustpilotConfigurationService';
        this.context = context;
    }


    status() {
        return this.httpClient
            .get(
                `/_info/${this.getApiBasePath()}/configuration/status`,
                {
                    headers: this.getBasicHeaders(),
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }

    connect(data) {
        const headers = this.getBasicHeaders();

        return this.httpClient
            .post(
                `/_action/${this.getApiBasePath()}/connect`,
                data,
                {
                    headers: headers,
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }

    disconnect(data) {
        const headers = this.getBasicHeaders();

        return this.httpClient
            .post(
                `/_action/${this.getApiBasePath()}/disconnect`,
                data,
                {
                    headers: headers,
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }

    getBusinessUnitConfiguration() {
        const headers = this.getBasicHeaders();

        return this.httpClient
            .get(
                `/_info/${this.getApiBasePath()}/configure/business-units`,
                {
                    headers: headers,
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }

    getTemplateConfiguration(businessUnit, type) {
        const headers = this.getBasicHeaders();

        return this.httpClient
            .get(
                `/_info/${this.getApiBasePath()}/configure/${businessUnit}/templates/${type}`,
                {
                    headers: headers,
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }
}

export default TrustpilotConfigurationService;
